import React from 'react';
import yasirImage from '../assets/yasir-abbas.jpg';

const Hero: React.FC = () => {
  return (
    <section className="bg-white section-padding pt-20">
      <div className="container-custom">
                                   <div className="grid lg:grid-cols-3 gap-8 lg:gap-12 items-start">
           {/* Image - Left Side */}
           <div className="order-1 lg:order-1 text-center lg:text-left">
             <div className="relative mb-4 mt-2 lg:mb-12 lg:mt-8">
               <img 
                 src={yasirImage} 
                 alt="Yasir Abbas - Lawyer and Policy Maker" 
                 className="w-64 h-64 sm:w-72 sm:h-72 lg:w-80 lg:h-80 object-cover object-[center_20%] rounded-lg shadow-xl mx-auto lg:mx-0"
               />
             </div>
             
             
             

           </div>
           
                       {/* Content - Right Side (Spans 2 columns) */}
            <div className="order-2 lg:order-2 lg:col-span-2 space-y-6">
              {/* Banner Text */}
              <div className="space-y-4 mt-4 lg:mt-8">
                <h2 className="text-xl font-semibold text-gray-800">
                  Lawyer & Policy Maker
                </h2>
              </div>
    
              {/* Description */}
              <div className="space-y-4">
                <p className="text-base text-gray-700 leading-relaxed max-w-4xl text-justify">
                  Thank you for visiting. I am Yasir Abbas, a lawyer and PhD candidate in Law at the University of Manchester, funded by the School of Social Sciences International PhD Studentship. My expertise spans international law, international relations, political affairs, and government relations. I provide political advice, legal and policy counsel, and strategic analysis and solutions to senior leadership.
                </p>
                <p className="text-base text-gray-700 leading-relaxed max-w-4xl text-justify">
                  I hold an LLM from the University of Sussex as a Chevening Scholar, along with undergraduate degrees in International Relations (Hons) and Law (LLB). I can be reached at <a href="mailto:yasir.abbas@manchester.ac.uk" className="text-orange-600 hover:text-orange-700 underline">yasir.abbas@manchester.ac.uk</a>
                </p>
              </div>

              {/* Notable Appointments - Above Languages */}
              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Notable Appointments</h3>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <span className="text-prestige-600 mr-2 mt-1 text-base">•</span>
                    <div>
                      <div className="font-medium text-gray-800 text-base mb-1">Coordinator/Special Assistant to Chief Minister on Law and Public Policy</div>
                      <div className="text-gray-600 text-sm">Government of Gilgit Baltistan</div>
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="text-prestige-600 mr-2 mt-1 text-base">•</span>
                    <div>
                      <div className="font-medium text-gray-800 text-base mb-1">Head Rule of Law & Service Delivery Unit</div>
                      <div className="text-gray-600 text-sm">Government of Gilgit Baltistan</div>
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="text-prestige-600 mr-2 mt-1 text-base">•</span>
                    <div>
                      <div className="font-medium text-gray-800 text-base mb-1">Member Board of Investment</div>
                      <div className="text-gray-600 text-sm">Gilgit Baltistan</div>
                    </div>
                  </li>
                </ul>
              </div>
    
              {/* Languages */}
              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Languages</h3>
                <div className="flex flex-wrap gap-3 max-w-4xl">
                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
                    <div className="font-medium text-gray-800 text-base">English</div>
                  </div>
                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
                    <div className="font-medium text-gray-800 text-base">Urdu</div>
                  </div>
                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
                    <div className="font-medium text-gray-800 text-base">Khowar</div>
                  </div>
                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
                    <div className="font-medium text-gray-800 text-base">Shina</div>
                  </div>
                </div>
              </div>

              {/* Areas of Interest */}
              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Areas of Interest</h3>
                <div className="flex flex-wrap gap-3 max-w-4xl">
                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
                    <div className="font-medium text-gray-800 text-base">International Law</div>
                  </div>
                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
                    <div className="font-medium text-gray-800 text-base">International Affairs</div>
                  </div>
                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
                    <div className="font-medium text-gray-800 text-base">Human Rights</div>
                  </div>
                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
                    <div className="font-medium text-gray-800 text-base">Climate Change</div>
                  </div>
                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
                    <div className="font-medium text-gray-800 text-base">Litigation</div>
                  </div>
                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
                    <div className="font-medium text-gray-800 text-base">Government Relations</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  );
};

export default Hero;
